import { DocumentEntity } from 'serviceWorker/repository/document/entity';

export function createUrlFromChecklistDocument(
  document: DocumentEntity
): string {
  return `/checklistItem/${document.checklistId}/norm`;
}

export function createUrlFromTemplateSectionDocument(
  document: DocumentEntity
): string {
  return `/section/${document.sectionId}`;
}

export function createUrlFromTemplateDocument(
  document: DocumentEntity
): string {
  const url = `/inspectionTemplate/${document.templateId}`;
  if (document.checklistId) {
    return url + createUrlFromChecklistDocument(document);
  }
  if (document.sectionId) {
    return url + createUrlFromTemplateSectionDocument(document);
  }

  return url + '/generalNorm';
}
